export function isNullOrUndefined<T>(obj: T): boolean {
  if (obj === null || obj === undefined) {
    return true;
  }
}
